import React from "react";
import { Link } from "@quintype/components";

export function NewsHeading({story={}, index}) {
    if(story.metadata['linked-story-slug']){
      return <Link id={index} key={story.id} href={ '/'+ story.metadata['linked-story-slug']}>
      <article dangerouslySetInnerHTML={{__html:story.headline}}></article></Link>
    } else {
      return <article id={index} key={story.id}>{story.headline}</article>
    }
}